/**
 * 既読履歴から、現存しないお知らせの分を落とす。
 *
 * `existingHrefs` が undefined（support サイトからの取得前・取得失敗）のときは剪定しない。
 * 空配列で剪定すると既読が全消しになるため、「お知らせが 0 件」と「まだ分からない」を区別する。
 *
 * @returns 書き込むべき新しい既読履歴。変更不要なら null
 */
export const pruneReadHrefs = (
	readHrefs: readonly string[],
	existingHrefs: readonly string[] | undefined,
): string[] | null => {
	if (!existingHrefs) return null;

	const existing = new Set(existingHrefs);
	const pruned = readHrefs.filter((href) => existing.has(href));

	return pruned.length === readHrefs.length ? null : pruned;
};
